import React, { FC } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useOrganizationList } from "@/hooks/management/useOrganizations.manage";
import { useAppTheme } from "@/utils/theme";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import { CreateProgramFormData } from "./validation.schema";
import Grid from "@mui/material/Grid2";
import { Typography } from "@mui/material";

type TabProgramOUsProps = {
  editMode?: boolean;
};

export const TabProgramOUs: FC<TabProgramOUsProps> = ({ editMode = false }) => {
  const theme = useAppTheme();
  const { t } = useTranslation("program");
  const { t: tCommon } = useTranslation("common");

  const { data, isLoadingOrganizations } = useOrganizationList();

  const {
    formState: { errors },
    setValue,
    watch,
  } = useFormContext<CreateProgramFormData>();

  const orgUnitIdsWatched = watch("orgUnitIds") as string[];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "1.25rem",
      }}
    >
      <Typography
        variant="titleSmall"
        fontWeight={theme.typography.fontWeightBold}
      >
        {t("messages.ou-section-info")}
      </Typography>
      <List sx={{ width: "100%", bgcolor: "background.paper" }}>
        {data?.organizations.map((organization) => {
          const labelId = `checkbox-list-label-${organization._id}`;

          return (
            <ListItem key={organization._id} disablePadding>
              <ListItemButton role={undefined} dense>
                <ListItemIcon
                  sx={{
                    minWidth: "30px",
                  }}
                >
                  <Checkbox
                    edge="start"
                    tabIndex={-1}
                    disableRipple
                    inputProps={{ "aria-labelledby": labelId }}
                    checked={orgUnitIdsWatched.some(
                      (it) => it == organization._id,
                    )}
                    onChange={(e) => {
                      let newValue;
                      if (e.target.checked) {
                        newValue = [...orgUnitIdsWatched, organization._id];
                      } else {
                        newValue = (orgUnitIdsWatched || []).filter(
                          (it) => it !== organization._id,
                        );
                      }
                      setValue("orgUnitIds", newValue);
                    }}
                  />
                </ListItemIcon>
                <ListItemText id={labelId} primary={organization.name} />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
      <Grid size={12}>
        {errors.orgUnitIds && (
          <Typography color="error" variant="body2">
            {errors.orgUnitIds.message ||
              tCommon("validations.validator_min_items", { count: 1 })}
          </Typography>
        )}
      </Grid>
    </Box>
  );
};
